<template>
  <v-container fluid>
    <v-row class="text-center" justify="center">
      <v-col cols="12" sm="8" md="7">
        <v-card
            class="elevation-12"
            max-width="800"
            min-width="400">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-col>
              <v-toolbar-title>
                {{ $t('Статистика активности по кварталу') }}
              </v-toolbar-title>
            </v-col>
          </v-toolbar>
          <v-card-text>
            <v-progress-linear
                height="5"
                class="mb-3"
                :active="isLoading"
                color="loader"
                indeterminate />
            <general-error v-if="!!generalError" />
            <ValidationObserver ref="report" @keydown.native.enter="focusOnBtn('getReportBtn')">
              <validatable-quarter-picker
                  :value="start"
                  rules="required"
                  :label="$t('Начало интервала')"
                  @change="startSelected" />
              <validatable-quarter-picker
                  :value="end"
                  rules="required"
                  :label="$t('Конец интервала')"
                  @change="endSelected" />
            </ValidationObserver>
          </v-card-text>
          <v-card-actions>
            <v-btn
                id="getReportBtn"
                ref="getReportBtn"
                v-test="{ btn: 'getReport' }"
                color="primary"
                :disabled="isLoading"
                @click.stop="getOrganizationsActivityReport">
              {{ $t('Получить отчет') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableQuarterPicker from '@/components/reused/ui/ValidatableQuarterPicker.vue'
  import { mapActions } from 'vuex'
  import { REPORTS } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      ValidatableQuarterPicker
    },
    data () {
      return {
        isLoading: false,
        start: {
          quarter: Number.parseInt(this.$moment().format('Q')),
          year: Number.parseInt(this.$moment().format('YYYY'))
        },
        end: {
          quarter: Number.parseInt(this.$moment().format('Q')),
          year: Number.parseInt(this.$moment().format('YYYY'))
        }
      }
    },
    methods: {
      ...mapActions(REPORTS.NAMESPACE, {
        getOrganizationsActivityReportAction: REPORTS.ACTIONS.GET_ORGANIZATIONS_ACTIVITY_REPORT
      }),
      startSelected: function (quarter) {
        this.start.quarter = quarter.quarter
        this.start.year = quarter.year
      },
      endSelected: function (quarter) {
        this.end.quarter = quarter.quarter
        this.end.year = quarter.year
      },
      getOrganizationsActivityReport: async function () {
        const result = await this.$refs.report.validate()
        if (!result) {
          return
        }
        try {
          this.isLoading = true
          const params = {
            startQuarter: this.start.quarter,
            startYear: this.start.year,
            endQuarter: this.end.quarter,
            endYear: this.end.year
          }
          await this.getOrganizationsActivityReportAction(params)
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      }
    }
  }
</script>
